// extracted by css-extract-rspack-plugin
export default {"cls1":"SubtopicSection-cls1_B5V","cls2":"SubtopicSection-cls2_PJ_ SubtopicSection-cls1_B5V"};